function initSwiper({ swiperSelector, swiperOptions = {} }) {
  const sw = document.querySelector(swiperSelector);

  if (!sw) return null;
  const wrapper = sw.querySelector('.swiper-wrapper');

  const baseOptions = {
    speed: 500,
    preloadImages: false,
    lazy: true,
    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.5,
      momentumVelocityRatio: 1,
    },
    mousewheel: {
      forceToAxis: true,
      invert: false,
      sensitivity: 1,
    },
    observer: true,
    observeParents: true,
  };

  if (sw.swiper) destroySwiper(sw);

  const instance = new Swiper(sw, {
    ...baseOptions,
    ...swiperOptions,
  });

  return instance;
}

function destroySwiper(sw) {
  if (!sw) return;
  if (sw.swiper) sw.swiper.destroy(true, true);
  return null;
}

/* Handle tab menu */
function initTabMenu(selector) {
    const activeClass = 'is-active';

    const tabMenu = document.querySelector(selector);
    if (!tabMenu) return;

    const heads = tabMenu.querySelectorAll('.tab-menu-head');
    const panels = tabMenu.querySelectorAll('.tab-menu-panel');

    if (!heads.length || !panels.length) return;

    function activateTab(targetId) {
    heads.forEach((head) => {
        const isTarget = head.dataset.target === targetId;

        head.classList.toggle(activeClass, isTarget);
    });

    panels.forEach((panel) => {
        const isTarget = panel.id === targetId;
        panel.classList.toggle(activeClass, isTarget);
    });
    }

    heads.forEach((head) => {
    head.addEventListener('click', () => {
        if (head.classList.contains(activeClass)) return;

        const targetId = head.dataset.target;
        if (!targetId) return;

        activateTab(targetId);
    });
    });
}